import { User } from '../../../account/dto/user';
import { UserProfilePicture } from '../../../image/dto/user-profile-picture';

/**
 * A teammate who has left product signals, as returned alongside `HighGuideCompanySignals`.
 *
 * The backend calls this shape `BaseUser`. It is a strict subset of the fields on `User`, plus `isAnonymous`, so it
 * is modelled as a subclass rather than a parallel type - the unsent fields simply stay undefined.
 *
 * Once HighGuide visibility permissions ship, a user who has opted out comes back with `isAnonymous: true` and their
 * `userId` replaced by the `anonymousUserId` sentinel. That sentinel is shared by every anonymous teammate, so it
 * must never be treated as a unique key.
 */
export class ProductSignalUser extends User {
  static readonly anonymousUserId = 'anonymous';

  public profilePicture: UserProfilePicture;
  public isAnonymous: boolean;

  override onDeserialize() {
    super.onDeserialize();
    this.profilePicture = window?.injector?.Deserialize?.instanceOf(UserProfilePicture, this.profilePicture);
  }

  isAnonymousUser(): boolean {
    return this.isAnonymous || this.userId === ProductSignalUser.anonymousUserId;
  }
}
